<a class="maps-link" target="_blank" [href]="link">{{ strasse }}, {{ plz }} {{ ort }}</a>
